import { apiClient } from "./api";
import config from "@/config/env";

export interface RAGAgent {
  agent_id: string;
  name: string;
  provider: string;
  status: string;
  [key: string]: any;
}

export interface AgentStats {
  agent_id: string;
  total_requests: number;
  avg_latency: number;
  success_rate: number;
  cost: number;
  [key: string]: any;
}

export interface ProviderSummary {
  [provider: string]: any;
}

export interface AgentRequest {
  id: string;
  timestamp: string;
  latency: number;
  success: boolean;
  cost: number;
  [key: string]: any;
}

export const externalRagApi = {
  getAgents: async (): Promise<{ agents: RAGAgent[] }> => {
    const res = await fetch(`${config.api.backendUrl}/api/v1/external-rag-agents`);
    return res.json();
  },
  getStats: async (): Promise<{ stats: AgentStats[] }> => {
    const res = await fetch(`${config.api.backendUrl}/api/v1/external-rag-agents/stats`);
    return res.json();
  },
  getProvidersSummary: async (): Promise<{ providers: ProviderSummary }> => {
    const res = await fetch(
      `${config.api.backendUrl}/api/v1/external-rag-agents/providers/summary`
    );
    return res.json();
  },
  getAgentRequests: async (
    agentId: string,
    limit: number = 50
  ): Promise<{ requests: AgentRequest[] }> => {
    const res = await fetch(
      `${config.api.backendUrl}/api/v1/external-rag-agents/${agentId}/requests?limit=${limit}`
    );
    return res.json();
  },
  createAgent: async (agent: Partial<RAGAgent>): Promise<any> => {
    const res = await apiClient.post(`/external-rag-agents`, agent);
    return res.data;
  },
};
